// eslint-disable-next-line no-restricted-imports -- grandfathered; prefer next/image for new code
import { Card, Flex, Image, Text, Box } from '@mantine/core'
import { Testimonial } from '@/components/Store/StoreTestimonials'
import TestimonialNavigation from './TestimonialNavigation'
import { motion } from 'framer-motion'

interface MobileTestimonialCardProps {
    testimonial: Testimonial
    onPrev: () => void
    onNext: () => void
    direction?: number // 1 for right (next), -1 for left (prev)
}

const MobileTestimonialCard: React.FC<MobileTestimonialCardProps> = ({
    testimonial,
    onPrev,
    onNext,
    direction = 1,
}) => {
    const contentVariants = {
        enter: {
            opacity: 0,
            x: direction === 1 ? 5 : -5,
            transition: { duration: 0.25 },
        },
        center: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.25 },
        },
        exit: {
            opacity: 0,
            x: direction === 1 ? -5 : 5,
            transition: { duration: 0.25 },
        },
    }

    return (
        <Card
            padding="xl"
            radius="md"
            bg="var(--gm-background-bg-highlight-container)"
            w="100%"
            h={{ base: 600, sm: 600, md: 500 }}
            style={{
                overflow: 'hidden',
                borderRadius: '16px',
            }}
        >
            <Flex direction="column" justify="space-between" h="100%">
                <motion.div
                    key={`content-${testimonial.id}`}
                    variants={contentVariants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                >
                    <Flex direction="column" align="left" gap={16}>
                        <Box
                            style={{
                                width: '100px',
                                height: '100px',
                                overflow: 'hidden',
                                marginBottom: '8px',
                            }}
                        >
                            <Image
                                src={`https://${process.env.NEXT_PUBLIC_ASSETS_DOMAIN}/${testimonial.mobileImageUrl}`}
                                alt={testimonial.customerName}
                                width="100%"
                                height="100%"
                                fit="cover"
                                style={{ objectFit: 'cover', objectPosition: 'right', borderRadius: '8px' }}
                            />
                        </Box>

                        <Text size="18px" c="var(--gm-foreground-fg-secondary)" fw="var(--gm-weight-text)" ta="left">
                            {testimonial.customerName} in {testimonial.location}
                        </Text>

                        <Text
                            size="24px"
                            fw="var(--gm-weight-small)"
                            lh="120%"
                            c="var(--gm-foreground-fg-primary)"
                            ta="left"
                            style={{
                                letterSpacing: 'var(--gm-display-m-letter-spacing)',
                                marginBottom: '12px',
                            }}
                        >
                            &quot;{testimonial.quote}&quot;
                        </Text>

                        <Text
                            size="16px"
                            c="var(--gm-foreground-fg-secondary)"
                            fw="var(--gm-weight-text)"
                            lh="var(--gm-text-l-line-height)"
                            ta="left"
                        >
                            {testimonial.description}
                        </Text>
                    </Flex>
                </motion.div>

                <TestimonialNavigation onPrev={onPrev} onNext={onNext} isMobile={true} />
            </Flex>
        </Card>
    )
}

export default MobileTestimonialCard
